export default {
  state: {
    collapse: false, // 导航栏收缩状态
    setting: false, //设置收缩
    navType: 'tag', //设置收缩
    logoShow: true,
    logoPosition: 'left',
    layout: '1'
  },
  getters: {
    collapse(state) {
      return state.collapse
    },
    setting(state) {
      return state.setting
    },
    navType(state) {
      return state.navType
    },
    logoShow(state) {
      return state.logoShow
    },
    logoPosition(state) {
      return state.logoPosition
    },
    layout(state) {
      return state.layout
    }
  },
  mutations: {
    setCollapse(state) {
      state.collapse = !state.collapse
    },
    setSetting(state) {
      state.setting = !state.setting
    },
    setNavType(state, navType) {
      state.navType = navType
    },
    setLogoShow(state, logoShow) {
      state.logoShow = logoShow
    },
    setLogoPosition(state, logoPosition) {
      state.logoPosition = logoPosition
    },
    setLayout(state, layout) {
      state.layout = layout
    },
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js